enum CvnaCategoryName {
  brakingAndTraction = 'Braking & Traction',
  cargoAndTowing = 'Cargo & Towing',
  comfortAndConvenience = 'Comfort & Convenience',
  entertainmentAndTechnology = 'Entertainment & Technology',
  exterior = 'Exterior',
  lighting = 'Lighting',
  performanceAndDrive = 'Performance & Drive',
  roofAndGlass = 'Roof & Glass',
  safetyAndSecurity = 'Safety & Security',
  seatingAndInterior = 'Seating & Interior',
  wheelsAndTires = 'Wheels & Tires'
}

export default CvnaCategoryName;
